/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponseData;

  constructor(
    err: DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse";
  }
}

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$inboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse(
        v,
      );
    });

/** @internal */
export type DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$outboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$Outbound,
    z.ZodTypeDef,
    DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse
  > = z.instanceof(
    DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$ {
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$inboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$outboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$Outbound` instead. */
  export type Outbound =
    DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdErrorResponse$Outbound;
}
